import React, { useState, useEffect, useContext } from 'react'

//
import { ButtonNew, Notification } from '../../storybook'
import { useLocalStorage } from '../../utils/local-storage'
import { getMicroCopy } from '../../utils/microcopy'
import { SiteDataContext } from '../page-wrapper'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'
import { BUTTON_VARIANT } from '../../storybook/ButtonNew/ButtonNew'

const CountrySwitcher = ({ allMarkets }) => {
  const settings = useContext(SiteDataContext)
  const microCopyData = useMicroCopyData()
  const { market, lang } = settings
  const { isoCode } = market

  const [dismissed, setDismissed] = useLocalStorage('dismissed', [])
  const [isNotificationOpen, setIsNotificationOpen] = useState(true)
  const [userCountry, setUserCountry] = useState(isoCode)
  const [userCountryTitle, setUserCountryTitle] = useState(isoCode)
  const [switchSlug, setSwitchSlug] = useState(null)

  const toggleIsNotificationOpen = () => {
    if (isNotificationOpen) {
      const values = [...dismissed]
      if (!values.includes(isoCode)) {
        values.push(isoCode)
        setDismissed(values)
      }
    }
    setIsNotificationOpen(!isNotificationOpen)
  }

  useEffect(() => {
    // Mock data for local development
    if (process.env.NODE_ENV === 'development') {
      // Simulate a different country than current isoCode
      const mockResponse = {
        country: 'BE' // Current client country
      }

      const countryOnTheList = Array.isArray(allMarkets)
        ? allMarkets?.find((m) => m.countryIsoCode === mockResponse.country)
        : null
      if (mockResponse.country && !!countryOnTheList && mockResponse.country !== isoCode) {
        const title = countryOnTheList.title
          ? getMicroCopy({
              key: `market.${String(mockResponse.country).toLowerCase()}`,
              data: microCopyData[lang]
            })
          : null
        const locales = countryOnTheList.locales

        if (locales) {
          setUserCountry(mockResponse.country)
          setUserCountryTitle(title)
          setSwitchSlug(locales)
        }
      }
      return
    }

    if (process.env.NEXT_PUBLIC_GET_COUNTRY_URL) {
      fetch(process.env.NEXT_PUBLIC_GET_COUNTRY_URL)
        .then((res) => res.json())
        .then((res) => {
          // Notification should be only displayed if user is on a valid country (market)
          const countryOnTheList = Array.isArray(allMarkets)
            ? allMarkets?.find((m) => m.countryIsoCode === res?.country)
            : null

          if (res?.country && !!countryOnTheList && res.country !== isoCode) {
            const title = countryOnTheList.title
              ? getMicroCopy({
                  key: `market.${String(res.country).toLowerCase()}`,
                  data: microCopyData[lang]
                })
              : null

            const locales = countryOnTheList.locales

            if (locales) {
              setUserCountry(res.country)
              setUserCountryTitle(title)
              setSwitchSlug(locales)
            }
          }
        })
        .catch((e) => console.error(e))
    }
  }, [isoCode, allMarkets])

  if (isoCode === userCountry || !switchSlug || dismissed.includes(isoCode)) {
    return null
  }

  return (
    <Notification
      handleClose={toggleIsNotificationOpen}
      isOpen={isNotificationOpen}
      text={`${getMicroCopy({
        key: 'switchLocationText',
        data: microCopyData[lang],
        tokens: {
          country: userCountryTitle
        }
      })}`}
      title={''}
    >
      {switchSlug.map((slug) => (
        <ButtonNew
          key={`switcher-${slug}`}
          size="md"
          variant={BUTTON_VARIANT.SECONDARY}
          url={`/${slug}`}
        >
          {`${getMicroCopy({
            key: `languages.${slug.split('-')[0]}`,
            data: microCopyData[lang]
          })} `}
        </ButtonNew>
      ))}
    </Notification>
  )
}

export default CountrySwitcher
